import React, { useState } from 'react';
import { Box, Modal, Typography } from '@mui/material';
import { useBookingStyles } from './styles';
import NewSessionIcon from '../../icons/NewSessionIcon';
import FutureSessionIcon from '../../icons/FutureSessionIcon';
import { useBookingsContext } from '../../contexts/BookingsContext';

interface BookSessionProps {
  open: boolean;
  onClose: () => void;
}

const BookSession = ({ open, onClose }: BookSessionProps) => {
  const styles = useBookingStyles();

  const { setEditBooking, setIsBookingModalOpen, setBookingModalUrl } =
    useBookingsContext();

  const handleCreateSpotBooking = () => {
    onClose();
    setEditBooking(null);
    setBookingModalUrl('booking-spot');
    setIsBookingModalOpen(true);
  };

  const handleScheduleBooking = () => {
    const url = `${window._env_?.BOOKING_APP_URL || process.env.REACT_APP_BOOKING_APP_URL}/services/?headless=1&dashboard=1`;

    onClose();
    setEditBooking(null);
    setBookingModalUrl(url);
    setIsBookingModalOpen(true);
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <>
          <Box sx={styles.modal}>
            <Typography sx={styles.title}>Book a VHC Session</Typography>
            <Box sx={styles.content}>
              <Box
                sx={styles.bookingBox}
                onClick={() => handleCreateSpotBooking()}>
                <Box sx={styles.boxText}>
                  <NewSessionIcon />
                  <Typography sx={styles.boxText}>
                    Invite a HomeOwner to start a session now
                  </Typography>
                </Box>
              </Box>
              {/*
              <Box
                sx={bookingStyles.bookingBox}
                onClick={() => handleScheduleBooking()}>
                <Box sx={bookingStyles.boxText}>
                  <FutureSessionIcon />
                  <Typography sx={bookingStyles.boxText}>
                    Book a session for the future
                  </Typography>
                </Box>
              </Box>
              */}
            </Box>
          </Box>
        </>
      </Modal>
    </>
  );
};

export default BookSession;
